import React from "react";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { NewBadge } from "../generic/NewBadge";
import NotificationManager from "../../common/notification/NotificationManager";
import { PASTE_CONFIGURATION_NOTIFICATION } from "../../utils/constants/notification";
import { formatMessage } from "../../utils/helpers/LanguageHelper";
import { CoObjectItem, TgkTableObjectSource } from "../interfaces/CoObject";
import { SourceEnum } from "../../api/models";
import { getClipboardText } from "../../utils/helpers/Clipboard";
import { parseJsonToType } from "../../utils/helpers/JsonHelper";

interface PasteObjectProps {
  objectType: "TABLE" | "CHART" | "AMOUNT" | "AMOUNT_AIH";
  onPasteObject: (pastedObject: CoObjectItem) => void;
}

export const PasteObject: React.FunctionComponent<PasteObjectProps> = (props) => {
  function handleUnsupported(objectType: string) {
    throw new Error(`Object type ${objectType} not supported`);
  }

  function handleTableAndChart(parsedObject: CoObjectItem) {
    let parsedSource = parsedObject.source as TgkTableObjectSource;

    // if (formNotLaunched(parsedObject))
    //   throw new Error(formatMessage("cof.createnewobject.pastsettings.message.error.textnotpasted"));

    parsedSource.objectSource = SourceEnum.FORM;
    parsedSource.inheritFormatImage = true;

    if (props.objectType === "CHART") {
      parsedSource.elabResultType = "IMAGE_STRINGBASE64";
    }
    parsedObject.source = parsedSource;
  }

  const pasteObjectFromClipboard = async () => {
    try {
      let clipboardText = await getClipboardText();
      let parsedObject = parseJsonToType<CoObjectItem>(clipboardText);

      switch (props.objectType) {
        case "CHART":
        case "TABLE":
          handleTableAndChart(parsedObject);
          break;
        default:
          handleUnsupported(props.objectType);
      }
      props.onPasteObject(parsedObject);
    } catch (e) {
      // eslint-disable-next-line no-undef
      console.error(e);
      NotificationManager.addNotification({
        key: PASTE_CONFIGURATION_NOTIFICATION,
        message: e.message
          ? e.message
          : formatMessage("cof.access.manageconfigurations.message.pasteconfigurationerror"),
        title: "Error",
        type: "error",
        closable: true,
        removeOnClose: true,
        isTemporary: true,
      });
    }
  };

  return (
    <div
      className="ms-Grid-col ms-sm12 ms-md12 ms-lg12"
      style={{
        marginTop: "25px",
        marginBottom: "25px",
      }}
    >
      <div>
        {formatMessage("cof.newobject.pastefromform")}
        <NewBadge></NewBadge>
        <PrimaryButton
          style={{ float: "right", minHeight: "20px", padding: "0px" }}
          text={formatMessage("cof.base.pastesettings")}
          onClick={pasteObjectFromClipboard}
        />
      </div>
    </div>
  );
};
